import { Box, styled, Typography } from '@mui/material'
import { Fragment } from 'react'
import { FieldErrors } from 'react-hook-form'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  padding: 0px 10px;
  margin: 0 auto;
`

const Message = styled(Typography)`
  color: red;
  font-size: 12px;
`

export const ErrorMessages = ({ errors }: Props) => {
  return (
    <Container>
      {Object.keys(errors).map(key => {
        const value = errors[key]

        if (Array.isArray(value)) {
          return (
            <Fragment key={key}>
              {value.root && (
                <Message key={key}>{value.root.message as string}</Message>
              )}
              {value[0] && (
                <Message key={key}>{value[0].value.message}</Message>
              )}
            </Fragment>
          )
        }

        return <Message key={key}>{value?.message as string}</Message>
      })}
    </Container>
  )
}

type Props = {
  errors: FieldErrors
}
